// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import "./adminlte";

// ADMINLTE + TURBO RELOADp
import "./ujs_links"

// PLUGINS
import "./overlayscrollbars_init";
import "./sortable_init";
import "./jsvectormap_init";


// CHARTS
// import "./apexcharts_init";
import "./dashboard";
import "./expenses_chart";
import "./sales_chart";
import "./sales_expenses_chart"

// BOOKINGS
import "./reservation_toggler"
import "./booking_filter"

// PURCHASE ORDERS
import "./purchase_items"

// SALES ORDERS
import "./sales_items"

// HAIR CARE ITEMS
import "./hair_care_items"




